import styled from "styled-components";

export const TruncatedName = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    flex-basis: 94px;
`;